const messages = {
  en: {
    table: {
      paginatorTemplate:
        "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
      pageReportTemplate: "Showing {first} to {last} of {totalRecords} records",
      /* stupid vue-18n doesn't support escaping curly braces properly despite the docs saying it can,
      so we have to use this template with
      $t('table.pageReportTemplate', {
        first: '{first}',
        last: '{last}',
        totalRecords: '{totalRecords}',
      })
      */
      filterBy: "Filter by {0}",
      filterByAny: "Any",
    },
    client: {
      table: {
        initials: "Initials",
        location: "Location",
        roomNumber: "Room number",
        supportHours: "Support hours",
      },
      levels: {
        level0: "Green",
        level1: "Amber",
        level2: "Red",
      },
      hours: {
        supportGeneralPerWeek: "General Support (hours)",
        support1to1PerWeek: "One to One Support (hours)",
        support2to1PerWeek: "Two to One Support (hours)",
        support3to1PerWeek: "Three to One Support (hours)",
        careGeneralPerWeek: "General Care (hours)",
        care1to1PerWeek: "One to One Care (hours)",
        care2to1PerWeek: "Two to One Care (hours)",
        caret3to1PerWeek: "Three to One Care (hours)",
        category: {
          support: "Support (hours p/w)",
          care: "Care (hours p/w)",
        },
      },
    },
    rotaUser: {
      table: {
        displayName: "Name",
        locations: "Place of work",
        dutiesQualifiedFor: "Duties qualified for",
      },
    },
    rotaAgency: {
      table: {
        name: "Name",
        shortName: "Short name",
      },
    },
    rotaActivity: {
      table: {
        location: "Location",
        startDate: "Date",
        title: "Activity",
        shifts: "Rota Shifts",
        startTime: "Time",
        appointmentStartTime: "Appointment",
        clients: "Client(s)",
        ActionIconID: "Type",
        type: "Type",
      },
      report: {
        start: "Start Activity",
        stop: "Stop / Finish Activity",
        markComplete: "Complete Activity",
        addNote: "Add Note",
        addNotePlaceholder: "Write a note for this report ...",
        addNoteWarning:
          "You have not written a detailed enough note. Please include some more details.",
        behaviour: "Challenging Behaviour",
        btn: {
          start: "Start Activity",
          stop: "Finish Activity",
          markComplete: "Mark Activity Completed",
          addNote: "Add Note",
          unableToStart: "Log Unable to Start",
        },
      },
    },
    rota: {
      table: {
        startDate: "Start Date",
        location: "Location",
        type: "Type",
        status: "Status",
        dateModified: "Last Updated",
        name: "Name",
      },
    },
    export: {
      activityReport: {
        headings: {
          activityTitle: "Activity Title",
          activityDate: "Activity Date",
          client: "Client",
          location: "Location",
          reportDate: "Report Date",
          reportTime: "Report Time",
          staff: "Staff",
          event: "Event",
          duration: "Duration",
          note: "Note",
        },
      },
    },
  },
};

export default messages;
